// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".EditMultiTableReservationDrawer__drawerContent___SDJn_{display:flex;flex-direction:column;row-gap:1rem}", "",{"version":3,"sources":["webpack://./src/restaurantAdmin/reservations/service/EditMultiTableReservationDrawer.scss"],"names":[],"mappings":"AAAA,wDACE,YAAA,CACA,qBAAA,CACA,YAAA","sourcesContent":[".drawerContent {\n  display: flex;\n  flex-direction: column;\n  row-gap: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"drawerContent": "EditMultiTableReservationDrawer__drawerContent___SDJn_"
};
export default ___CSS_LOADER_EXPORT___;
